import React from 'react';
import EvaluationEventPartner from './EvaluationEventPartner';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'evaluation-event-partner';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <EvaluationEventPartner
        key={`${type}-${index}`}
        evaluation={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
